import { Card, ThemeProvider } from "@mui/material";
import LoadingScreen from "components/loading/LoadingScreen";
import Table from "components/table/Table";
import { ALL_OPTION } from "constant";
import { useFormik } from "formik";
import { usePagination } from "hooks/usePagination";
import { useMemo } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  useExportListBusiness,
  useGetListBusiness,
  useGetListPbxType,
} from "service/query/business-management.query";
import muiTheme from "theme/muiTheme";

import BusinessFilter from "./components/BusinessFilter";

const Business = () => {
  const DEFAULT_FORM_VALUE = {
    pbxType: ALL_OPTION.value,
    name: "",
    contractCode: "",
  };

  const [filter, setFilter] = useState(
    convertFormValueToFilter(DEFAULT_FORM_VALUE)
  );

  const { data: listBusiness, isFetching } = useGetListBusiness();
  const { data: listPbxType } = useGetListPbxType();
  const { refetch: handleExportListBusiness } = useExportListBusiness();

  const filteredData = useMemo(
    () =>
      filter
        ? listBusiness?.filter(
            (item) =>
              (filter.pbxType ? item.pbxType === filter.pbxType : true) &&
              (filter.name
                ? item.name
                    ?.toLowerCase()
                    .includes(filter.name.trim().toLowerCase())
                : true) &&
              (filter.contractCode
                ? item.contract?.code
                    ?.toLowerCase()
                    .includes(filter.contractCode.trim().toLowerCase())
                : true)
          )
        : listBusiness,
    [filter, listBusiness]
  );

  const {
    page,
    pageSize,
    clientData,
    clientTotal,
    handleChangePage,
    handleChangePageSize,
  } = usePagination(filteredData);

  const columns = useMemo(
    () => [
      {
        id: "pbxType",
        name: "Loại tổng đài",
        render: (record) =>
          record.pbxType
            ? listPbxType?.find((item) => item.pbxType === record.pbxType)?.name
            : null,
      },
      { id: "businessCode", name: "Mã nghiệp vụ" },
      { id: "name", name: "Tên nghiệp vụ" },
      {
        id: "contractCode",
        name: "Mã hợp đồng",
        render: (record) => record.contract?.code,
      },
      {
        id: "phoneNumber",
        name: "Đầu số",
        render: (record) =>
          record.isActive !== false && (
            <Link
              to={{
                pathname: `${process.env.REACT_APP_PATH}/business-management/business-phone-number`,
                businessCode: record.businessCode,
              }}>
              Danh sách đầu số
            </Link>
          ),
      },
    ],
    [listPbxType]
  );

  const handleSubmit = (formValue) => {
    setFilter(convertFormValueToFilter(formValue));
    handleChangePage(1);
  };

  const formik = useFormik({
    initialValues: DEFAULT_FORM_VALUE,
    onSubmit: handleSubmit,
  });

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ p: 2, mb: 2 }}>
        <BusinessFilter
          formik={formik}
          onClickDownload={handleExportListBusiness}
        />
      </Card>
      <Card>
        <Table
          columns={columns}
          data={clientData}
          toolbar={{
            title: "Danh sách nghiệp vụ",
          }}
          showHoverRow
          pagination={{
            page,
            pageSize,
            totalItems: clientTotal,
            onPageChange: handleChangePage,
            onPageSizeChange: handleChangePageSize,
          }}
        />
      </Card>

      <LoadingScreen loading={isFetching} />
    </ThemeProvider>
  );
};

const convertFormValueToFilter = ({ pbxType, name, contractCode }) => ({
  ...(pbxType !== ALL_OPTION.value && {
    pbxType,
  }),
  ...(name && {
    name,
  }),
  ...(contractCode && {
    contractCode,
  }),
});

export default Business;
